<template>
    <b-form-group label-for="select-questionnaires">
        <template slot="label">
            <strong>{{ $t('form.label.questionnaire') + '*' }}</strong>
        </template>
        <questionnaires
            :state="state"
            close-on-select
            clear-on-select
            :options="options"
            :selected="selected"
            :loading="isLoading"
            :internal-search="false"
            aria-describedby="questionnaires-aria"
            :noOptions="$t('values.withoutQuestionnairesAvailable')"
            :placeholder="$t('form.placeholder.questionnaireEvaluation')"
            @changeValue="onChangeValue"
        />
        <b-form-invalid-feedback id="questionnaires-aria">
            {{ $t('form.validations.questionnaireRequired') }}
        </b-form-invalid-feedback>
    </b-form-group>
</template>
<script>
import { Select, mapperToOptions } from '@/views/components/selects'
import { getQuestionnairesAvailableToEvaluate } from '@/views/values/api'

export default {
    components: {
        Questionnaires: Select,
    },
    props: {
        userId: {
            type: Number,
            required: true,
        },
        state: {
            type: Boolean,
            default: () => null,
        },
        selected: {
            type: Object,
            default: () => null,
        },
    },
    data() {
        return {
            options: [],
            isLoading: false,
        }
    },
    mounted() {
        this.getQuestionnaires()
    },
    methods: {
        onChangeValue(newValue) {
            this.$emit('update:selected', newValue)
            this.$emit('change-value', newValue)
        },
        getQuestionnaires() {
            this.isLoading = true
            return getQuestionnairesAvailableToEvaluate(this.userId)
                .then(questionnaires => {
                    this.options = mapperToOptions(questionnaires)
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
    },
}
</script>
